import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

const useHeaderReportLinkText = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "custom_ui_labels.header_report_link_text");
};

export { useHeaderReportLinkText };
